import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const SubjectReportChart = ({ subjectStatusReport }) => {
  const [subjectStatusReportBarGraph, setSubjectStatusReportBarGraph] = useState({
    series: [
      {
        name: "No. of Subject",
        data: subjectStatusReport || [],
      },
    ],

    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      stroke: { width: 1, colors: ["#fff"] },
      plotOptions: {
        bar: { horizontal: true },
      },
      xaxis: {
        categories: ["Discontinuation", "Ongoing", "Completed"],
        labels: {
          style: {
            color: ["#103C5E99", "#103C5E99", "#103C5E99"],
            fontSize: "12px",
          },
        },
      },
      fill: { opacity: 1 },
      colors: ["#103C5E99", "#103C5E99", "#103C5E99"],
      legend: {
        position: "bottom",
        showForSingleSeries: true,
      },
    },
  });

  useEffect(() => {
    setSubjectStatusReportBarGraph((prevChartData) => ({
      ...prevChartData,
      series: [{ data: subjectStatusReport || [] }],
    }));
  }, [subjectStatusReport]);

  return (
    <>
      <ReactApexChart
        options={subjectStatusReportBarGraph.options}
        series={subjectStatusReportBarGraph.series}
        type="bar"
        height={240}
      />
    </>
  );
};

export default SubjectReportChart;
